import React from 'react';
import { render } from 'react-dom';
import { Router, Route, Switch } from 'react-router-dom';
import history from './services/history';
import { REACT_ROUTES } from './constants/react_routes';

import { Provider } from 'react-redux'
import configureStore from './store/store';

import { MuiThemeProvider } from '@material-ui/core';
import { theme } from './theme/theme';

import PublicRoute from './routes/public_route';
import PrivateRoute from './routes/private_route';

import Layout from './components/layout/layout';

import SignIn from './components/sign_in/sign_in';
import SignUp from './components/sign_up/sign_up';

import Scheduler from './components/scheduler/scheduler';

import CustomerList from './components/customer/customer_list';
import Customer from './components/customer/customer';

import WorkerList from './components/worker/worker_list';
import Worker from './components/worker/worker';

import PlaceList from './components/place/place_list';
import Place from './components/place/place';

import ArticleTabs from './components/articles/article_tabs';
import Article from './components/articles/article/article';
import Percentage from './components/articles/percetages/percentage';

import DigitalRecord from './components/scheduler/digital_record';
import AreaList from './components/area/area_list';
import Area from './components/area/area'

import SubAreaList from './components/sub_area/sub_area_list';
import SubArea from './components/sub_area/sub_area';

import AddUser from './components/user/add_user';
import AddUserPassword from './components/user/add_user_password';

import Settings from './components/settings/settings';

import TherapyList from './components/therapy/therapy_list';
import Therapy from './components/therapy/therapy';

import ProtocolsList from './components/protocols/protocols_list';

import ReportsTabs from './components/reports/reports_tabs';

import ExpenseTabs from './components/expenses/expense_tabs';
import Expense from './components/expenses/expense/expense';
import ExpenseType from './components/expenses/expense_type/expense_type';

import MlpList from './components/mlp/mlp_list';
import Mlp from './components/mlp/mlp';

import ErrorPage from './components/error_page/error_page';
import NotFound from './components/not_found/not_found';

render (
    <Provider store={configureStore()}>
        <Router history={history}>
            <MuiThemeProvider theme={theme}>
                <Switch>
                    <PublicRoute path={REACT_ROUTES.HOME} component={SignIn} exact />
                    <PublicRoute path={REACT_ROUTES.SIGN_UP} component={SignUp} exact />
                    <PublicRoute path={`${REACT_ROUTES.ADD_USER_PASSWORD}/:token`} component={AddUserPassword} />

                    <PrivateRoute path={REACT_ROUTES.SCHEDULER} component={Scheduler} layout={Layout} exact />

                    <PrivateRoute path={REACT_ROUTES.CUSTOMERS} component={CustomerList} layout={Layout} exact />
                    <PrivateRoute path={`${REACT_ROUTES.CUSTOMER}/:uuid?`} component={Customer} layout={Layout} exact />

                    <PrivateRoute path={REACT_ROUTES.WORKERS} component={WorkerList} layout={Layout} exact />
                    <PrivateRoute path={`${REACT_ROUTES.WORKER}/:uuid?`} component={Worker} layout={Layout} exact />

                    <PrivateRoute path={REACT_ROUTES.PLACES} component={PlaceList} layout={Layout} exact />
                    <PrivateRoute path={`${REACT_ROUTES.PLACE}/:uuid?`} component={Place} layout={Layout} exact />

                    <PrivateRoute path={REACT_ROUTES.ARTICLE_TABS} component={ArticleTabs} layout={Layout} exact />
                    <PrivateRoute path={`${REACT_ROUTES.ARTICLE}/:uuid?`} component={Article} layout={Layout} exact />
                    <PrivateRoute path={`${REACT_ROUTES.PERCENTAGE}/:uuid?`} component={Percentage} layout={Layout} exact />

                    <PrivateRoute path={`${REACT_ROUTES.DIGITAL_RECORD}/:uuid?`} component={DigitalRecord} layout={Layout} exact />
                    <PrivateRoute path={REACT_ROUTES.AREAS} component={AreaList} layout={Layout} exact />
                    <PrivateRoute path={`${REACT_ROUTES.AREA}/:uuid?`} component={Area} layout={Layout} exact />

                    <PrivateRoute path={REACT_ROUTES.SUB_AREAS} component={SubAreaList} layout={Layout} exact />
                    <PrivateRoute path={`${REACT_ROUTES.SUB_AREA}/:uuid?`} component={SubArea} layout={Layout} exact />

                    <PrivateRoute path={REACT_ROUTES.THERAPIES} component={TherapyList} layout={Layout} exact />
                    <PrivateRoute path={`${REACT_ROUTES.THERAPY}/:uuid?`} component={Therapy} layout={Layout} exact />

                    <PrivateRoute path={REACT_ROUTES.PROTOCOLS} component={ProtocolsList} layout={Layout} exact />

                    <PrivateRoute path={REACT_ROUTES.REPORT_TABS} component={ReportsTabs} layout={Layout} exact />

                    <PrivateRoute path={REACT_ROUTES.EXPENSE_TABS} component={ExpenseTabs} layout={Layout} exact />
                    <PrivateRoute path={`${REACT_ROUTES.EXPENSE}/:uuid?`} component={Expense} layout={Layout} exact />
                    <PrivateRoute path={`${REACT_ROUTES.EXPENSE_TYPE}/:uuid?`} component={ExpenseType} layout={Layout} exact />

                    <PrivateRoute path={REACT_ROUTES.MLPS} component={MlpList} layout={Layout} exact />
                    <PrivateRoute path={`${REACT_ROUTES.MLP}/:uuid?`} component={Mlp} layout={Layout} exact />

                    <PrivateRoute path={REACT_ROUTES.ADD_USER} component={AddUser} layout={Layout} exact />

                    <PrivateRoute path={REACT_ROUTES.SETTINGS} component={Settings} layout={Layout} exact />

                    <Route path={REACT_ROUTES.ERROR_PAGE} component={ErrorPage} exact />

                    <Route component={NotFound} />
                </Switch>
            </MuiThemeProvider>
        </Router>
    </Provider>,
	document.getElementById('root')
);
